module.exports = __webpack_public_path__ + "img/实验实训室.f2fa03a2.svg";